import {
    handleActions,
    Action,
} from 'redux-actions';

import {
    QC_JOB_STATE_SET,
    GET_DELIVERY_JOBS_STATUS,
    RESET_QC_JOB_STATE,
    RESET_JOB_DELIVERY_STATUS,
    QcJobStatusIndicatorPayload,
} from './QCToolsActions';
import {QcJobStatusIndicatorState} from '../JobStatusIndicator/JobStatusIndicatorTypes';
import {DeliveryJobsStatusPayload} from '../QCToolsTypes';

type QcJobStatusIndicatorAction = Action<QcJobStatusIndicatorPayload>;
type DeliveryJobStatusAction = Action<DeliveryJobsStatusPayload>;

export const setQcJobState = (state: QcJobStatusIndicatorState, action: QcJobStatusIndicatorAction) => {
    if (action.error)
        return initialState;

    const {payload} = action;

    return {
        statusIndicators: payload,
        isLoading: false,
    };
};

export const resetQCJobState = () => {
    return initialState;
}

export const setJobDeliveryStatusState = (state: DeliveryJobsStatusPayload, action: DeliveryJobStatusAction) => {
    if (action.error)
        return jobDeliveryInitialState;

    const {payload} = action;
    const {
        isDeliveryStarted,
        deliveryStartedAt,
    } = payload;

    return {
        isDeliveryStarted,
        deliveryStartedAt,
    };
};

export const resetJobDeliveryStatus = () => {
    return jobDeliveryInitialState;
}

export const initialState = {
    statusIndicators: [],
    isLoading: true,
};

export const jobDeliveryInitialState = {
    isDeliveryStarted: false,
    deliveryStartedAt: '',
};

const handlers = {
    [QC_JOB_STATE_SET]: setQcJobState,
    [RESET_QC_JOB_STATE]: resetQCJobState,
};

const jobDeliveryHandlers = {
    [GET_DELIVERY_JOBS_STATUS]: setJobDeliveryStatusState,
    [RESET_JOB_DELIVERY_STATUS]: resetJobDeliveryStatus,
};

export const jobDeliveryStatus = handleActions(jobDeliveryHandlers, jobDeliveryInitialState);

export default handleActions(handlers, initialState);
